module.exports = __webpack_public_path__ + "img/girl-sitting-on-laptop.3a2db80.svg";